import { CardReturnOrder } from '@/entities/profile-page/returnOrders/CardReturnOrder/ui/CardReturnOrder'
import './ui/CardReturnOrder.scss'
export default CardReturnOrder
